import { type PreliminaryQuestionsDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import { convertStringToLocalDateDTO } from '../utils/dateUtil';

const getValueFromQueryParameter = (key: string): string => {
    const queryParameters = window.location.search;
    return new URLSearchParams(queryParameters).get(key) ?? '';
};

export function usePreliminaryQuestions(): {
    getDataFromQueryParams: () => PreliminaryQuestionsDTO;
} {
    const getDataFromQueryParams = (): PreliminaryQuestionsDTO => {
        const flavourName = getValueFromQueryParameter('forsikringsnavn').replaceAll('-', ' ');
        if (flavourName === '') return {};

        const preliminaryQuestions: PreliminaryQuestionsDTO = {
            flavourToUpdate: flavourName
        };

        switch (flavourName?.toLowerCase()) {
            case 'ulykkesforsikring':
                preliminaryQuestions.adultAccident = {
                    employmentCode: getValueFromQueryParameter('beskaftigelseskode')
                };
                break;
            case 'borneforsikring': {
                const numberOfChildren = getValueFromQueryParameter('antal-born');
                preliminaryQuestions.childInsurance = {
                    numberOfChildren:
                        numberOfChildren !== '' ? parseInt(numberOfChildren) : undefined
                };
                break;
            }
            case 'rejseforsikring': {
                const numberOfHousehold = getValueFromQueryParameter('antal-beboere');
                preliminaryQuestions.travel = {
                    numberOfHousehold:
                        numberOfHousehold !== '' ? parseInt(numberOfHousehold) : undefined
                };
                break;
            }
            case 'indboforsikring':
                preliminaryQuestions.privateContent = {
                    dawaId: getValueFromQueryParameter('addresse-id')
                };
                break;
            case 'bilforsikring':
                preliminaryQuestions.car = {
                    licenseNumber: getValueFromQueryParameter('nummerplade'),
                    brand: getValueFromQueryParameter('marke'),
                    model: getValueFromQueryParameter('model')
                };
                break;
            case 'katteforsikring': {
                const catQueryBirthDate = getValueFromQueryParameter('fodselsdato');
                preliminaryQuestions.cat = {
                    birthdate:
                        catQueryBirthDate !== ''
                            ? convertStringToLocalDateDTO(catQueryBirthDate)
                            : undefined
                };
                break;
            }
            case 'hundeforsikring': {
                const dogQueryBirthDate = getValueFromQueryParameter('fodselsdato');
                preliminaryQuestions.dog = {
                    birthdate:
                        dogQueryBirthDate !== ''
                            ? convertStringToLocalDateDTO(dogQueryBirthDate)
                            : undefined
                };
                break;
            }
        }
        return preliminaryQuestions;
    };

    return { getDataFromQueryParams };
}
